import axios from '../services/axios';
import { sanitizeClientSessionData } from './sanitizeClientSessionData';


export async function getCurrentClientData (storage) {
    try{

        let clientData = storage.get('CLIENT_DATA');
      
        if (!clientData || clientData === 'undefined') {
            storage.exclude('CLIENT_DATA');
            return null;
        }

        const {token, sessionUUID} = clientData;

        const res = await axios.get(`/smartmenu/validate/client/data`, {
            params:{
                id: clientData.id,
                companyId: clientData.company_id,
            }
        })
        
        if(res.status == 200){
            const sanitized = sanitizeClientSessionData({
                ...res.data,
                token: token,
                sessionUUID: sessionUUID ?? null,
            });

            return sanitized;
        }


    } catch (e) {
        console.error(e);
        throw e;
    }
}